export class CouponsQuery {
  constructor () {
    this.applicationCode = undefined;
    this.current = undefined;
    this.pageSize = undefined;
    this.localBusinessId = undefined;
    this.localBusinessName = undefined;
  }

  static get KEYS () {
    return {
      LOCAL_BUSINESS_ID: 'localBusinessId',
      APPLICATION_CODE: 'applicationCode',
      LOCAL_BUSINESS_NAME: 'localBusinessName'
    };
  }
}
